import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0369e8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "time_selector" }

import i18n from '@/plugins/i18n'
import { computed, withDefaults } from 'vue'

type PropsType = {
  modelValue: string
  pickerOptions?: { [key: string]: string }
  disabled?: boolean
  placeholder?: string
  clearable?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeSelector',
  props: {
    modelValue: null,
    pickerOptions: { default: () => ({ start: '00:00', step: '01:00', end: '23:00' }) },
    disabled: { type: Boolean, default: false },
    placeholder: { default: i18n.global.t('time_selector.select_time') },
    clearable: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: string): void
  (e: 'change', value: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: string, pickerOptions: { [key: string]: string }, disabled: boolean, placeholder: string, clearable: boolean };





const selectedValue = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value)
    // TODO 親コンポーネントで'update:modelValue'を利用すればchangeは不要だが、利用しているコンポーネントの修正がなるべく発生しないように2重でchangeイベントを追加している。
    emit('change', value)
  },
})

return (_ctx: any,_cache: any) => {
  const _component_el_time_select = _resolveComponent("el-time-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_time_select, {
      modelValue: _unref(selectedValue),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedValue) ? (selectedValue).value = $event : null)),
      start: __props.pickerOptions.start,
      end: __props.pickerOptions.end,
      step: __props.pickerOptions.step,
      placeholder: __props.placeholder,
      size: "small",
      clearable: __props.clearable,
      editable: false,
      disabled: __props.disabled
    }, null, 8, ["modelValue", "start", "end", "step", "placeholder", "clearable", "disabled"])
  ]))
}
}

})